import React, { Component } from 'react';
import { AtlasLink } from '../atlas-link';
import WithContentfulEditMode from '../with-contentful-edit';
import { string, element, func } from 'prop-types';

class Product extends Component {
    render() {
        const {
            title,
            className,
            icon,
            url,
            productBlurb,
            contentfulEditIcon,
            setRef
        } = this.props;
        return (
            <li
                data-testid="product_link"
                className={['products__item', className].join(' ')}
            >
                <AtlasLink
                    setRef={setRef}
                    href={url}
                    className="products__link"
                    text={title}
                    dataName={
                        className === 'dropdown__product-item'
                            ? `${title} product dropdown button`
                            : `${title} button`
                    }
                >
                    <img
                        src={icon}
                        alt=""
                        height="32"
                        width="32"
                        className="products__icon"
                    />
                    <div>
                        {title}
                        {productBlurb && (
                            <p
                                data-testid="product_blurb"
                                className="products__blurb"
                            >
                                {productBlurb}
                            </p>
                        )}
                    </div>
                </AtlasLink>
                {contentfulEditIcon && contentfulEditIcon}
            </li>
        );
    }
}

Product.propTypes = {
    setRef: func,
    title: string,
    className: string,
    icon: string.isRequired,
    url: string.isRequired,
    productBlurb: string,
    contentfulEditIcon: element
};

const ProductWithCEM = WithContentfulEditMode(Product);

export { Product, ProductWithCEM };
